var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.5C2.5 13.6427 2.5 16.8807 3.59835 17.857C4.6967 18.8333 6.46447 18.8333 10 18.8333C13.5355 18.8333 15.3033 18.8333 16.4016 17.857C17.5 16.8807 17.5 13.6427 17.5 10.5",
    stroke: "#1C274D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2168 12.3343L17.2228 10.8325C17.7191 10.6836 17.9672 10.6091 18.1247 10.4307C18.1553 10.396 18.183 10.3587 18.2075 10.3194C18.3332 10.1173 18.3332 9.85823 18.3332 9.34012C18.3332 7.29833 18.3332 6.27743 17.7724 5.58818C17.6646 5.4557 17.5435 5.33462 17.411 5.22683C16.7218 4.66602 15.7009 4.66602 13.6591 4.66602H6.34061C4.29882 4.66602 3.27792 4.66602 2.58867 5.22683C2.45619 5.33462 2.33511 5.4557 2.22732 5.58818C1.6665 6.27743 1.6665 7.29833 1.6665 9.34012C1.6665 9.85822 1.6665 10.1173 1.79215 10.3194C1.81663 10.3587 1.84434 10.396 1.87501 10.4307C2.03246 10.6091 2.28059 10.6836 2.77684 10.8324L7.7829 12.3343",
    stroke: "#1C274D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4165 4.66602C6.10271 4.64863 6.79921 4.21177 7.03271 3.56628C7.03989 3.54643 7.04725 3.52434 7.06198 3.48016L7.08336 3.41602C7.11851 3.31055 7.1361 3.2578 7.15491 3.21102C7.39507 2.61362 7.95785 2.20799 8.60054 2.16906C8.65087 2.16602 8.70646 2.16602 8.81764 2.16602H11.1824C11.2936 2.16602 11.3492 2.16602 11.3995 2.16906C12.0422 2.20799 12.605 2.61362 12.8451 3.21102C12.864 3.2578 12.8815 3.31054 12.9167 3.41602L12.9381 3.48016C12.9527 3.52408 12.9602 3.54648 12.9673 3.56628C13.2008 4.21177 13.897 4.64863 14.5832 4.66602",
    stroke: "#1C274D",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 10.916H8.33317C8.10305 10.916 7.9165 11.1026 7.9165 11.3327V13.1339C7.9165 13.3043 8.02023 13.4575 8.17842 13.5208L8.76187 13.7542C9.55657 14.072 10.4431 14.072 11.2378 13.7542L11.8212 13.5208C11.9794 13.4575 12.0832 13.3043 12.0832 13.1339V11.3327C12.0832 11.1026 11.8966 10.916 11.6665 10.916Z",
    stroke: "#1C274D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerIcon);
export default __webpack_public_path__ + "static/media/PartnerIcon.9b0418d96896a2b2993f9335d00f9f85.svg";
export { ForwardRef as ReactComponent };